import { TRANSLATION_KEYS } from "../constants/TranslationKeys";
import { PIX } from "../models/PIX";

export function mapPixTypeToTranslation(pixType: PIX["type"]) {
  return {
    email: TRANSLATION_KEYS.pixTypeEmail,
    cnpj: TRANSLATION_KEYS.pixTypeCNPJ,
    randomKey: TRANSLATION_KEYS.pixTypeRandomKey,
    phoneNumber: TRANSLATION_KEYS.pixTypePhoneNumber,
  }[pixType];
}
